(function () {
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var site = document.querySelector('.site');
  var io = null;

  function countUp(el, dur, delay) {
    var target = parseInt(el.getAttribute('data-count'), 10) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    if (reduce) { el.textContent = prefix + target + suffix; return; }
    var t0 = 0;
    function tick() {
      if (!t0) t0 = Date.now();
      var p = Math.min(1, (Date.now() - t0) / dur);
      el.textContent = prefix + Math.round(target * (1 - Math.pow(1 - p, 3))) + suffix;
      if (p < 1) setTimeout(tick, 40);
    }
    el.textContent = prefix + '0' + suffix;
    setTimeout(tick, delay || 0);
  }

  /* apparition au scroll */
  function observe(root) {
    var els = root.querySelectorAll('[data-rv]');
    if (!io) { for (var i = 0; i < els.length; i++) els[i].classList.add('in'); return; }
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }
  if (!reduce && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
    site && site.classList.add('js');
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
        var nums = e.target.querySelectorAll('[data-count]');
        for (var k = 0; k < nums.length; k++) countUp(nums[k], 2400, 0);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
  }

  /* en-tête : masqué en descendant, menu mobile */
  function initHeader(root) {
    var hdr = root.querySelector('.hdr');
    if (!hdr) return;
    var burger = root.querySelector('.burger');
    var menu = root.querySelector('.mmenu');
    var open = false;
    function setMenu(v) {
      open = v;
      burger.classList.toggle('x', v);
      burger.setAttribute('aria-expanded', v ? 'true' : 'false');
      burger.setAttribute('aria-label', v ? 'Fermer le menu' : 'Ouvrir le menu');
      menu.hidden = !v;
      hdr.classList.remove('up');
    }
    burger && burger.addEventListener('click', function () { setMenu(!open); });
    menu && menu.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    var last = 0, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = window.pageYOffset || 0;
        var dy = y - last;
        if (open) return;
        if (y < 120) hdr.classList.remove('up');
        else if (dy > 6) hdr.classList.add('up');
        else if (dy < -6) hdr.classList.remove('up');
        if (Math.abs(dy) > 6 || y < 120) last = y;
      });
    }, { passive: true });
  }

  /* hero : diaporama */
  function initHero(root) {
    var hero = root.querySelector('[data-hero]');
    if (!hero) return;
    var imgs = hero.querySelectorAll('.hx-img');
    var segs = hero.querySelectorAll('.hx-seg');
    var data = JSON.parse(hero.getAttribute('data-slides') || '[]');
    var n = imgs.length, i = 0, timer;
    var pos = hero.querySelector('.hx-k'), ttl = hero.querySelector('.hx-ct'), cat = hero.querySelector('.hx-cc');
    function show(k) {
      i = (k + n) % n;
      for (var j = 0; j < n; j++) {
        imgs[j].classList.toggle('on', j === i);
        if (segs[j]) {
          segs[j].classList.remove('on');
          if (j === i) { void segs[j].offsetWidth; segs[j].classList.add('on'); }
        }
      }
      if (data[i]) {
        pos.textContent = 'Réalisation ' + ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + n).slice(-2);
        ttl.textContent = data[i].title;
        cat.textContent = data[i].cat;
      }
    }
    function start() { clearInterval(timer); if (!reduce && n > 1) timer = setInterval(function () { show(i + 1); }, 6000); }
    hero.querySelector('[data-hero-prev]').addEventListener('click', function () { show(i - 1); start(); });
    hero.querySelector('[data-hero-next]').addEventListener('click', function () { show(i + 1); start(); });
    show(0); start();
    var num = hero.querySelector('.hx-num[data-count]');
    if (num) countUp(num, 1500, 900);
  }

  /* galerie des réalisations */
  function initGallery(root) {
    var g = root.querySelector('[data-gallery]');
    if (!g) return;
    var imgs = g.querySelectorAll('.gv-img');
    var infos = g.querySelectorAll('.gv-info');
    var ths = g.querySelectorAll('.gv-th');
    var count = g.querySelector('.gv-num');
    var box = g.querySelector('.gv-thumbs');
    var stage = g.querySelector('.gv-stage');
    var n = imgs.length, i = 0, timer, stopped = false, tx = null;
    if (!n) return;
    function show(k, byUser) {
      if (byUser) { stopped = true; clearInterval(timer); }
      i = ((k % n) + n) % n;
      [imgs, infos, ths].forEach(function (list) {
        for (var j = 0; j < list.length; j++) list[j].classList.toggle('on', j === i);
      });
      for (var t = 0; t < ths.length; t++) ths[t].setAttribute('aria-pressed', t === i ? 'true' : 'false');
      if (count) count.textContent = ('0' + (i + 1)).slice(-2);
      var el = ths[i];
      if (box && el && box.scrollWidth > box.clientWidth + 2) {
        box.scrollTo({ left: el.offsetLeft - (box.clientWidth - el.clientWidth) / 2, behavior: 'smooth' });
      }
    }
    g.querySelector('.gv-prev').addEventListener('click', function () { show(i - 1, true); });
    g.querySelector('.gv-next').addEventListener('click', function () { show(i + 1, true); });
    for (var t = 0; t < ths.length; t++) (function (idx) { ths[idx].addEventListener('click', function () { show(idx, true); }); })(t);
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1, true); }
    });
    stage.addEventListener('touchstart', function (e) { var p = e.touches && e.touches[0]; tx = p ? p.clientX : null; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      var p = e.changedTouches && e.changedTouches[0];
      if (tx == null || !p) return;
      var dx = p.clientX - tx; tx = null;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1), true);
    });
    if (!reduce && !stopped && n > 1) timer = setInterval(function () { show(i + 1); }, 5000);
  }

  /* carrousel des avis */
  function initReviews(root) {
    var c = root.querySelector('[data-reviews]');
    if (!c) return;
    var track = c.querySelector('.car-track');
    var dots = c.querySelectorAll('.dot');
    var n = dots.length, i = 0, timer;
    function show(k) {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      for (var j = 0; j < n; j++) dots[j].classList.toggle('on', j === i);
    }
    function start() { clearInterval(timer); if (!reduce && n > 1) timer = setInterval(function () { show(i + 1); }, 5500); }
    for (var d = 0; d < n; d++) (function (idx) { dots[idx].addEventListener('click', function () { show(idx); start(); }); })(d);
    start();
  }

  function init(root) {
    initHeader(root);
    initHero(root);
    initGallery(root);
    initReviews(root);
    observe(root);
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
